import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { Brand } from "@/components/Brand";
import { SERVICES } from "@/lib/siteContent";

const navCls = ({ isActive }) => `text-sm font-medium transition-colors ${isActive ? "text-slate-900" : "text-slate-500 hover:text-slate-900"}`;

const ServicesMenu = () => (
  <div className="group relative">
    <button data-testid="nav-servizi" className="flex items-center gap-1 text-sm font-medium text-slate-500 transition-colors hover:text-slate-900">
      Servizi <ChevronDown className="h-3.5 w-3.5 transition-transform group-hover:rotate-180" />
    </button>
    <div className="invisible absolute left-1/2 top-full w-72 -translate-x-1/2 pt-3 opacity-0 transition-[opacity,visibility] group-hover:visible group-hover:opacity-100">
      <div className="rounded-xl border border-slate-200 bg-white p-2 shadow-xl">
        {SERVICES.map((s) => (
          <Link key={s.slug} to={`/servizi/${s.slug}`} data-testid={`nav-servizio-${s.slug}`} className="block rounded-lg px-3 py-2.5 text-sm text-slate-700 hover:bg-slate-50 hover:text-slate-900">
            {s.nav}
          </Link>
        ))}
      </div>
    </div>
  </div>
);

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="no-print sticky top-0 z-40 border-b border-slate-200/70 bg-white/80 backdrop-blur-md">
      <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6">
        <Brand />
        <nav className="hidden items-center gap-8 md:flex">
          <NavLink to="/" end className={navCls} data-testid="nav-home">Home</NavLink>
          <ServicesMenu />
          <NavLink to="/normativa" className={navCls} data-testid="nav-normativa">Normativa</NavLink>
          <NavLink to="/contatti" className={navCls} data-testid="nav-contatti">Contatti</NavLink>
          <Link to="/informative" data-testid="nav-informative" className="rounded-md bg-slate-900 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-blue-600">Informative condomini</Link>
        </nav>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle" aria-label="Menu">
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>
      {open && (
        <nav className="space-y-1 border-t border-slate-200 bg-white px-6 py-4 md:hidden" data-testid="nav-mobile-menu" onClick={() => setOpen(false)}>
          <Link to="/" className="block py-2 text-sm">Home</Link>
          {SERVICES.map((s) => <Link key={s.slug} to={`/servizi/${s.slug}`} className="block py-2 text-sm">{s.nav}</Link>)}
          <Link to="/normativa" className="block py-2 text-sm">Normativa</Link>
          <Link to="/contatti" className="block py-2 text-sm">Contatti</Link>
          <Link to="/informative" className="mt-2 block rounded-md bg-slate-900 px-4 py-2.5 text-center text-sm font-medium text-white">Informative condomini</Link>
        </nav>
      )}
    </header>
  );
};
